import axios from "axios";

export default {
    rushCoupon() {
        return axios.get("/course/Coupon/rushCoupon");
    }
}